[
  { "row": "Public", "col": "Public data", "fillable": true, "generator": "" },
  { "row": "Public", "col": "Internal data", "fillable": false, "generator": "G2" },
  { "row": "Public", "col": "Secret data", "fillable": false, "generator": "G2" },
  { "row": "Internal", "col": "Public data", "fillable": true, "generator": "" },
  { "row": "Internal", "col": "Internal data", "fillable": true, "generator": "" },
  { "row": "Internal", "col": "Secret data", "fillable": false, "generator": "G2" },
  { "row": "Secret", "col": "Public data", "fillable": true, "generator": "" },
  { "row": "Secret", "col": "Internal data", "fillable": true, "generator": "" },
  { "row": "Secret", "col": "Secret data", "fillable": true, "generator": "" }
]
